import React from 'react';
import { Box, Button } from '@mui/material';
import { AI_GRADIENT, aiGradientButtonSx, AIGradientSpinner, AIGradientText } from './AIGradient.styles';

export { AI_GRADIENT, AI_GRADIENT_ANIMATED, AIGradientText, AIGradientSpinner } from './AIGradient.styles';

interface AIGradientButtonProps {
  onClick?: () => void;
  disabled?: boolean;
  children: React.ReactNode;
  size?: 'small' | 'medium' | 'large';
}

export const AIGradientButton = ({ onClick, disabled, children, size }: AIGradientButtonProps) => (
  <Button onClick={onClick} disabled={disabled} size={size} sx={aiGradientButtonSx}>
    <Box component="img" src="/images/scalar_ai_white.png" alt="Scalar AI" sx={{ width: 18, height: 18 }} />
    {children}
  </Button>
);
